module.exports = __webpack_public_path__ + "static/img/14000392.223d6f20.png";